import Layout from "@components/Layout";
import HomeHotel10Container from "@containers/HomeHotel10Container";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import { getServer } from "@translations/next";
import get from "lodash/get";
import StrapiService from "@services/StrapiService";
import RoomService from "@services/RoomService";
import FooterService from "@services/FooterService";
// import StoryArticleService from "@services/StoryArticleService";
// import OfferService from "@services/OfferService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <HomeHotel10Container />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = get(params, "locale", "en");
  StrapiService.set("id", "hotel10-home-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const resRoom = await RoomService.find({
    populate: ["thumbnail", "images", "thumbnailBackground"],
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  // const resArticle = await StoryArticleService.find({
  //   populate: ["thumbnail", "category"],
  //   page: 1,
  //   pageSize: 4,
  //   locale,
  //   filters: {
  //     hotels: {
  //       slug: {
  //         $eq: "amanaki-thao-dien",
  //       },
  //     },
  //   },
  // });

  // const resOffer = await OfferService.find({
  //   filters: {
  //     hotel: {
  //       slug: {
  //         $eq: "amanaki-thao-dien",
  //       },
  //     },
  //   },
  //   populate: ["thumbnail", "category"],
  //   page: 1,
  //   pageSize: 2,
  //   locale,
  // });

  // Get Stay Connected
  // StrapiService.set("id", "hotel10-stay-connected");
  // const resInspired = await StrapiService.find({
  //   populate: "deep",
  //   locale,
  // });

  return {
    hotel: "amanaki-thao-dien",
    pageData: {
      ...get(res, "data", {}),
      // stayConnected: get(resInspired, "data", {}),
    },
    rooms: get(resRoom, "data", []),
    footerData,
    // articles: get(resArticle, "data", []),
    // offers: get(resOffer, "data", []),
  };
});
